export const GLOBAL_HANDLER = 'GLOBAL_HANDLER'
export const GET_MESSAGE_LIMIT = 30
export const INIT_SENDBIRD = 'INIT_SENDBIRD'
export const MAX_COUNT = '+9'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const RESET_CHANNELS = 'RESET_CHANNELS'
export const RESET_USERS = 'RESET_USERS'
export const RESET_MESSAGES = 'RESET_MESSAGES'
export const SET_TYPING = 'SET_TYPING'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_PAGE_SIZE_USER = 'SET_PAGE_SIZE_USER'
export const SET_SEARCH_TERM_USER = 'SET_SEARCH_TERM_USER'
export const SET_CHANNEL_CHECKED = 'SET_CHANNEL_CHECKED'
export const SET_USER_CHECKED = 'SET_USER_CHECKED'
export const SET_MESSAGE_CHECKED = 'SET_MESSAGE_CHECKED'
export const SET_CHANNELS = 'SET_CHANNELS'
export const SET_USERS = 'SET_USERS'
export const SET_CHANNEL_MESSAGE_COUNT = 'SET_CHANNEL_MESSAGE_COUNT'
export const SET_MESSAGES = 'SET_MESSAGES'
export const RESET_REQUESTS = 'RESET_REQUESTS'
export const SET_REQUESTS = 'SET_REQUESTS'



// WEBPACK FOOTER //
// ./src/store/modules/chat/types.js